import { render } from "./presentercta.vue?vue&type=template&id=0fad61dc&scoped=true"
import script from "./presentercta.vue?vue&type=script&lang=js"
export * from "./presentercta.vue?vue&type=script&lang=js"

import "./presentercta.vue?vue&type=style&index=0&id=0fad61dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0fad61dc"

export default script